export type memberType = 'new' | 'exist';
